import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import expandFill from '@iconify/icons-eva/expand-fill';
import attach2Fill from '@iconify/icons-eva/attach-2-fill';
import collapseFill from '@iconify/icons-eva/collapse-fill';
import roundAddPhotoAlternate from '@iconify/icons-ic/round-add-photo-alternate';
// material
import { useTheme, styled } from '@material-ui/core/styles';
import {
    Box,
    Input,
    Portal,
    Button,
    Divider,
    Backdrop,
    IconButton,
    Typography,

    useMediaQuery,
    Stack,
    Avatar,
    Badge,
    TextField,
    InputAdornment
} from '@material-ui/core';

import ChatMessageList from '../../components/_dashboard/chat/ChatMessageListFacebook';
import EmojiPicker from '../../components/EmojiPicker';
//import ChatMessageInput from '../../components/_dashboard/chat/ChatMessageInput';
import { PATH_DASHBOARD } from '../../routes/paths';
import { useRef } from 'react';
import { useDispatch, useSelector } from '../../redux/store';
import ChatMessageInput from '../../components/_dashboard/facebook/ChatMessageInput';
import { getMoreMesageConversation, sendMessage } from '../../redux/slices/conversationFacebook';
import { useSnackbar } from 'notistack5';

//
// ----------------------------------------------------------------------
const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 24,
    height: 24,
    border: `1px solid ${theme.palette.background.paper}`,
}));
const RootStyle = styled('div')(({ theme }) => ({
    right: 0,
    bottom: 0,
    zIndex: 1999,
    minHeight: 440,
    outline: 'none',
    display: 'flex',
    position: 'fixed',
    overflow: 'hidden',
    flexDirection: 'column',
    margin: theme.spacing(3),
    boxShadow: theme.customShadows.z20,
    borderRadius: theme.shape.borderRadiusMd,
    backgroundColor: theme.palette.background.paper
}));

const InputStyle = styled(Input)(({ theme }) => ({
    padding: theme.spacing(0.5, 3),
    borderBottom: `solid 1px ${theme.palette.divider}`
}));

// ----------------------------------------------------------------------


export default function ChatWindowMiniFacebook({ onCloseWindowChat, isOpenWindowFacebook, onMinimizeWindowFacebook, infoToChat }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch();
    const { conversationContent, infoUserSelected, endPage, error } = useSelector(state => state.conversationFacebook);
    const [fullScreen, setFullScreen] = useState(false);
    const [message, setMessage] = useState('');
    const conversation = useState({});
    const fileInputRef = useRef(null);
    const [page, setPage] = useState(1);
    console.log(infoUserSelected)
    const { enqueueSnackbar } = useSnackbar();

    const loadMoreMessage = async () => {
        if (!endPage) {
          dispatch(getMoreMesageConversation({ id_conversation: infoUserSelected.id_conversation, page_id: infoUserSelected.page_id, user_id: infoUserSelected.user_id, page: page + 1 }));
          setPage(page + 1);
        }
        return null;
      }
    const handleSendMessage = async (value) => {
        dispatch(sendMessage({ ...value, page_id: infoUserSelected.page_id }));

    };
    useEffect(() => {
        if (error.response?.data?.message[0]) {
            enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        }

    }, [error]);
    useEffect(() => {
        const refreshMessage = () => {
            setPage(1);
        }
        if (infoUserSelected?.id_conversation) {
            refreshMessage();
        }
    }, [infoUserSelected]);
    const handleExitFullScreen = () => {
        setFullScreen(false);
    };

    const handleEnterFullScreen = () => {
        setFullScreen(true);
    };

    const handleMinimize = () => {
        onMinimizeWindowFacebook();
        setFullScreen(false);
    };
    const handleClose = (uid) => {
        onCloseWindowChat(uid, "facebook");
        setFullScreen(false);
    };
    const handleAttach = () => {
        fileInputRef.current.click();
    };
    if (!isOpenWindowFacebook) {
        return null;
    }

    return (
        <Portal>
            <Backdrop open={fullScreen || isMobile} sx={{ zIndex: 1998 }} />
            <RootStyle
                sx={{
                    ...(fullScreen && {
                        top: 0,
                        left: 0,
                        zIndex: 1999,
                        margin: 'auto',
                        width: {
                            xs: `calc(100% - 24px)`,
                            md: `calc(100% - 80px)`
                        },
                        height: {
                            xs: `calc(100% - 24px)`,
                            md: `calc(100% - 80px)`
                        }
                    }),
                    width: {
                        lg: '20%',
                        xl: '18%',
                    },
                    mr: "4%"
                }}
            >
                <Box
                    sx={{
                        pl: 2,
                        pr: 2,
                        height: 60,
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <Stack width={"68%"} direction="row" alignItems="center">

                        <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            badgeContent={
                                <SmallAvatar src={"/static/icons/icons8-facebook.svg"} alt="Channel" />
                            }
                        >
                            <Avatar src={infoToChat.urlImage} sx={{ width: 40, height: 40 }} />
                        </Badge>
                        <Stack width={"68%"}>
                            <Typography variant="subtitle2" sx={{ ml: 1, textOverflow: "ellipsis" }} noWrap>
                                {infoToChat.name}
                            </Typography>
                            <Typography variant="subtitle2" sx={{ ml: 1, textOverflow: "ellipsis" }} noWrap>
                                {infoToChat.page_name}
                            </Typography>
                        </Stack>



                    </Stack>
                    {/* <Typography variant="h6">New Message</Typography> */}

                    <IconButton onClick={fullScreen ? handleExitFullScreen : handleEnterFullScreen}>
                        <Icon icon={fullScreen ? collapseFill : expandFill} width={20} height={20} />
                    </IconButton>
                    <IconButton onClick={handleMinimize}>
                        <Icon icon="ri:subtract-fill" width={20} height={20} />
                    </IconButton>
                    <IconButton onClick={() => handleClose(infoUserSelected.user_id)}>
                        <Icon icon={closeFill} width={20} height={20} />
                    </IconButton>



                </Box>

                <Divider />

                {/* <InputStyle disableUnderline placeholder="To" />

                <InputStyle disableUnderline placeholder="Subject" /> */}
                <Box sx={{ height: 120, flexGrow: 1, display: 'flex', overflow: 'hidden' }}>
                    {infoUserSelected &&
                        <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}>
                            <ChatMessageList uid={infoUserSelected.id_conversation} infoUserSelected={infoUserSelected} pageCurrent={page} conversation={conversationContent ? conversationContent : []} loadMoreMessage={loadMoreMessage} user_id={infoUserSelected.user_id} />
                            <Divider />
                            <ChatMessageInput
                                user_id={infoUserSelected.user_id}
                                onSend={handleSendMessage}
                                disabled={false}
                            />
                        </Box>
                    }

                    {/* {mode === 'DETAIL' && <ChatRoom conversation={conversation} participants={[]} />} */}
                </Box>

                {/* <Box sx={{ py: 2, px: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <InputAdornment position="start">
                        <EmojiPicker value={message} setValue={setMessage} />
                    </InputAdornment>
                    <TextField
                        id="standard-textarea"
                        placeholder="Nhập tin nhắn..."
                        multiline
                        variant="standard"
                        fullWidth
                        disableUnderline
                    />
                    <IconButton size="small" sx={{ ml: 1, mr: 1 }}>
                        <Icon icon="mingcute:send-plane-fill" width={24} height={24} />
                    </IconButton>
                    <IconButton size="small" sx={{ ml: 1, mr: 1 }}>
                        <Icon icon={roundAddPhotoAlternate} width={24} height={24} onClick={handleAttach} />
                    </IconButton>
                    <IconButton size="small">
                        <Icon icon={attach2Fill} width={24} height={24} onClick={handleAttach} />
                    </IconButton>
                  
                     <input type="file" ref={fileInputRef} style={{ display: 'none' }} />
                </Box> */}
            </RootStyle>
        </Portal>
    );
}
